import React, { forwardRef } from "react";
import InputMask from "react-input-mask";
import { TextField as MUITextField, TextFieldProps } from "@mui/material";
import { useTheme } from "contexts";
import { Validations } from "helpers";
import { Constants } from "utils";

type Props = TextFieldProps & {
  sx?: any;
  id?: string;
  type?: string;
  name?: string;
  placeholder?: string;
  value?: any;
  mask?: string;
  focused?: boolean;
  disabled?: boolean;
  required?: boolean;
  multiline?: boolean;
  size?: "small" | "medium" | undefined;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
};

export const TextField = forwardRef((props: Props, ref: React.Ref<any>) => {
  const { theme } = useTheme();

  function renderTextField() {
    const conditionalProps = !props.mask
      ? {
          value: props.value,
          onBlur: props.onBlur,
          disabled: props.disabled,
          onChange: props.onChange,
        }
      : {};

    return (
      <MUITextField
        {...props}
        {...conditionalProps}
        variant="outlined"
        type={props.type}
        id={props.id}
        ref={ref}
        size={props.size}
        autoComplete="off"
        name={props.name}
        label={props.label}
        autoFocus={props.focused}
        minRows={props.multiline ? Constants.TEXTAREA.MIN : undefined}
        maxRows={props.multiline ? Constants.TEXTAREA.MAX : undefined}
        multiline={props.multiline}
        placeholder={props.placeholder}
        required={props.required ?? false}
        hiddenLabel={!Validations.hasValue(props.label as string)}
        sx={{
          width: 1,
          borderRadius: theme.border.radius,
          "& .MuiFormLabel-root.Mui-disabled": {
            color: theme.color.font.accent,
          },
          "& .MuiInputBase-input": {
            color: theme.color.font.color,
            borderRadius: theme.border.radius / 4,
            "&.Mui-disabled": {
              opacity: 0.8,
              WebkitTextFillColor: theme.color.font.accent,
            },
            "& + .MuiOutlinedInput-notchedOutline": {
              borderColor: theme.color.border.color,
            },
            "&:focus": {
              "& + .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.color.accent.color,
              },
            },
          },
          ...props.sx,
        }}
      />
    );
  }

  return props.mask ? (
    <InputMask
      // disabled={props.disabled}
      mask={props.mask}
      value={props.value}
      onBlur={props.onBlur}
      onChange={props.onChange}
    >
      {renderTextField()}
    </InputMask>
  ) : (
    renderTextField()
  );
});
